<template>
  <a-modal
    :width="612"
    centered
    class="stu-qr-modal"
    :visible="visible"
    @cancel="handleCancel"
    :title="userName"
    :footer="null"
  >
    <div class="qr-step">
      <div class="step-content">
        <div class="step-title">
          <p>第1步</p>
          <p>微信扫码</p>
          <p>打开小括狐家长端</p>
        </div>
        <div class="step-wrap">
          <img src="../../../static/images/wx.jpeg" alt="" />
        </div>
      </div>
      <div class="step-content">
        <div class="step-title">
          <p>第2步</p>
          <p>小括狐家长端扫码</p>
          <p>绑定学生帐号</p>
        </div>
        <div class="step-wrap">
          <canvas ref="qrCanvas" class="qr-canvas" />
        </div>
      </div>
    </div>
  </a-modal>
</template>
<script>
import QRCode from 'qrcode'
export default {
  data() {
    return {
      userName: ''
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleCancel() {
      this.$emit('update:visible', false)
    },
    showQr({ userId, userName }) {
      this.userName = userName
      this.$nextTick(async () => {
        const { qrCanvas } = this.$refs
        qrCanvas.style.visibility = 'hidden'
        const res = await this.$service.common.getQRcodeStr({
          userId
        })
        QRCode.toCanvas(qrCanvas, res, {
          margin: 0
        }, error => {
          if (error) console.error(error)
          console.log('success!')
          qrCanvas.style.visibility = 'visible'
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
.stu-qr-modal {
  :deep(.ant-modal-body) {
    padding: 0;
  }
  :deep(.ant-modal-header) {
    padding: 0 24px !important;
    display: flex;
    align-items: center;
    height: 54px !important;
  }
  :deep(.ant-modal-close) {
    height: 54px !important;
    margin-top: -1px !important;
  }
}
.qr-step {
  padding: 40px;
  display: flex;
  justify-content: space-between;
}
.step-title {
  margin-bottom: 24px;
  text-align: center;
  p {
    line-height: 22px;
    font-weight: 400;
    color: #505873;
    &:first-child {
      font-weight: 700;
      margin-bottom: 8px;
    }
    &:last-child {
      color: #98A2B2;
    }
  }
}
.step-wrap {
  width: 246px;
  height: 246px;
  border: 1px solid #DFE2E6;
  border-radius: 12px;
  box-sizing: border-box;
  padding: 27px;
  img {
    width: 100%;
    height: 100%;
  }
}
.qr-canvas {
  width: 100% !important;
  height: 100% !important;
}
</style>